/**
 * @desc 齐货状态下OMS申请发货
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(body: defs.fulfilment.OrderApplyOperationRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/rpc/outPlan/applyShip`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
